import { Controller } from "@hotwired/stimulus";

/**
 * Echap referme l'infobulle de la signature d'article.
 *
 * WCAG 1.4.13 demande qu'un contenu apparu au survol ou au focus puisse etre
 * renvoye sans deplacer le pointeur ni le focus, des lors qu'il recouvre autre
 * chose. L'infobulle deborde sur le debut de l'article, donc elle est
 * concernee. Le CSS n'ecoute pas le clavier : ce controleur ne fait que poser
 * et retirer un attribut, l'affichage reste decrit dans post.erb.
 */
export default class extends Controller {
  static targets = ["note"];

  dismiss(event) {
    if (event.key !== "Escape") return;
    // Ne rien retenir quand l'infobulle n'est pas affichee, sinon un Echap
    // frappe ailleurs dans la page laisserait un attribut qui bloque le survol
    // suivant.
    if (getComputedStyle(this.noteTarget).visibility !== "visible") return;

    this.element.dataset.noteDismissed = "";
  }

  restore() {
    delete this.element.dataset.noteDismissed;
  }
}
